/**
 * Validation utilities for parameters and inputs
 */

/**
 * Regular expression for validating alphanumeric parameters with hyphens
 */
export const PARAM_VALIDATION_REGEX = /^[a-zA-Z0-9-_]+$/;

/**
 * Type guard that validates a parameter string
 * Checks if the parameter is defined and matches the allowed pattern (alphanumeric and hyphens only)
 *
 * @param param - The parameter to validate
 * @returns True if the parameter is a valid non-empty string matching the pattern
 */
export const isValidParam = (param: string | undefined): param is string => {
  return !!param && PARAM_VALIDATION_REGEX.test(param);
};

/**
 * Validates multiple parameters at once
 *
 * @param params - Array of parameters to validate
 * @returns True if all parameters are valid
 */
export const areValidParams = (
  params: Array<string | undefined>
): params is string[] => {
  return params.every(isValidParam);
};
